import { render, staticRenderFns } from "./bsAttrCard.vue?vue&type=template&id=32d0e58a&scoped=true"
import script from "./bsAttrCard.vue?vue&type=script&lang=js"
export * from "./bsAttrCard.vue?vue&type=script&lang=js"
import style0 from "./bsAttrCard.vue?vue&type=style&index=0&id=32d0e58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0e58a",
  null
  
)

export default component.exports